module.exports = __webpack_public_path__ + "static/media/iconClose2.7530cda3.svg";